import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import generateCalendar from './generateCalendar';
const Calendar = generateCalendar(momentGenerateConfig);
export default Calendar;
